import { Link } from "react-router-dom";
import { Logo } from "@/components/Header";

export function Footer() {
  return (
    <footer className="mt-24 bg-slate-950 text-slate-400" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-4 max-w-sm text-sm leading-relaxed">
            L'annuaire des artisans, commerçants, fabricants et fournisseurs de toute la France. Données issues du répertoire officiel SIRENE et des avis de la communauté.
          </p>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-semibold text-white">Particuliers</p>
          <Link to="/recherche" className="block hover:text-white">Trouver un pro</Link>
          <Link to="/connexion" className="block hover:text-white">Créer un compte</Link>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-semibold text-white">Professionnels</p>
          <Link to="/mon-espace" className="block hover:text-white">Revendiquer ma fiche</Link>
          <Link to="/tarifs" className="block hover:text-white">Nos formules</Link>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs">© {new Date().getFullYear()} Qui Fait Quoi</div>
    </footer>
  );
}
